<script setup lang="ts">
import { computed, ref } from 'vue';
import { CollapseContent, DisplaySeparator } from '..';
import { FormLayout } from '../Form';

const props = defineProps<{
    collapsable?: boolean;
    openByDefault?: boolean;
    heading?: string;
}>();

const text = ref(props.heading ?? '');
const open = ref(props.openByDefault ?? true);

const icon = computed(() => {
    return open.value ? 'fa-chevron-up' : 'fa-chevron-down';
});
</script>
<template>
    <div v-if="collapsable">
        <FormLayout>
            <DisplaySeparator
                class="collapsable"
                v-model="text"
                @click="open = !open"
                :icon="icon"
                :collapsed="!open"
            />
            <CollapseContent :visible="open">
                <FormLayout>
                    <slot />
                </FormLayout>
            </CollapseContent>
        </FormLayout>
    </div>
    <slot v-else />
</template>
